import { useState, useEffect, useMemo } from 'react';
import SideBarSkeleton from '../../Component/SideBarSkeleton';
import { Get, Post, Delete, Patch } from '../../Axios/AxiosFunctions';
import { useSelector } from 'react-redux';
import
{
  TextField,
  MenuItem,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Button,
  CircularProgress,
  Tabs,
  Tab,
} from '@mui/material';
import { Close, Refresh } from '@mui/icons-material';
import { rolesOptions } from '../../constant/commonData';
import LeadsTable from './LeadsTable';
import { apiUrl } from '../../config/apiUrl';
import { MdChat } from 'react-icons/md';
import { toast } from 'react-toastify';
import NotesDetailPopup from '../../Component/NotesDetail';
import { moment } from '../../utils/timeUtils';
import { startOutlookLogin } from '../../utils/outlook';

// Update these functions in your frontend
const addToDeletedLeads = ( data, accessToken ) =>
{
  return Post( `${apiUrl}/api/v1/deleted-leads`, data, accessToken );
};

const addToDeletedPhones = ( data, accessToken ) =>
{
  return Post( `${apiUrl}/api/v1/deleted-leads/phone`, data, accessToken );
};

const getDeletedPhones = ( accessToken ) =>
{
  return Get( `${apiUrl}/api/v1/deleted-leads/deleted-phones`, accessToken );
};

const getDeletedEmails = ( accessToken ) =>
{
  return Get( `${apiUrl}/api/v1/deleted-leads/deleted-emails`, accessToken );
};

const isEmailDeleted = ( email, accessToken ) =>
{
  const encodedEmail = encodeURIComponent( email );
  return Get( `${apiUrl}/api/v1/deleted-leads/is-deleted/${encodedEmail}`, accessToken );
};

const restoreEmail = ( email, accessToken ) =>
{
  const encodedEmail = encodeURIComponent( email );
  return Delete( `${apiUrl}/api/v1/deleted-leads/${encodedEmail}`, accessToken );
};


const filterDenverbbsEmails = (data) => {
  return data.filter(item => {
    const email = item.email?.toLowerCase() || '';
    return !email.endsWith('@denverbbs.com');
  });
};
const Leads = () =>
{
  const [ leadsData, setLeadsData ] = useState( [] );
  const [ customLeads, setCustomLeads ] = useState( [] );
  const [ loading, setLoading ] = useState( true );
  const {
    access_token: accessToken,
    company_id: companyId,
    outlookAuthenticated: outlookAuthenticated,
  } = useSelector( ( state ) => state?.authReducer || {} );
  const userId = useSelector( ( state ) => state.authReducer.user?._id );
  const [ editId, setEditId ] = useState( null );
  const [ showZoomEdit, setShowZoomEdit ] = useState( false );
  const [ saveLoading, setSaveLoading ] = useState( false );
  const [ deleteLoadingSet, setDeleteLoadingSet ] = useState( new Set() );
  const [ zoomEditData, setZoomEditData ] = useState( {
    oldEmail: '',
    newEmail: '',
    firstName: '',
    lastName: '',
    phone: '',
    address: '',
    role: '',
    leadType: '',
  } );
  const [ contactsEmails, setContactsEmails ] = useState( [] );
  const [ currentTab, setCurrentTab ] = useState( 0 );
  const [ mergedLeadsState, setMergedLeadsState ] = useState( [] );
  const [ zoomLeadsState, setZoomLeadsState ] = useState( [] );
  const [ outlookLeadsState, setOutlookLeadsState ] = useState( [] );
  const [ combinedLeadsState, setCombinedLeadsState ] = useState( [] );
  const [allContacts, setAllContacts] = useState([]);
  const [ actionLoading, setActionLoading ] = useState( new Set() );
  const [ phoneTabCount, setPhoneTabCount ] = useState( 0 );
  const [ deletedEmails, setDeletedEmails ] = useState( new Set() );
  const [ deletedPhones, setDeletedPhones ] = useState( new Set() );
  const [ deletedOutlookPhones, setDeletedOutlookPhones ] = useState( new Set() );
  const [ deleteLoading, setDeleteLoading ] = useState( new Set() );
  const [ emailSearch, setEmailSearch ] = useState( '' );
  const [ phoneSearch, setPhoneSearch ] = useState( '' );
  const [ leadsSearch, setLeadsSearch ] = useState( '' );
  const [ contactSearch, setContactSearch ] = useState( '' );
  // Chat modal state variables
  const [ notesPopupAnchor, setNotesPopupAnchor ] = useState( null );
  const [ notes, setNotes ] = useState( [] );
  const [ phoneCallSummaries, setPhoneCallSummaries ] = useState( [] );
  const [ selectedItem, setSelectedItem ] = useState( null );
  const [ selectedNote, setSelectedNote ] = useState( null );
  const [ refreshing, setRefreshing ] = useState( false );
  const [ syncing, setSyncing ] = useState( false );

  // Fetch deleted emails on component mount
  useEffect( () =>
  {
    const fetchDeletedEmails = async () =>
    {
      try
      {
        const response = await getDeletedEmails( accessToken );
        if ( response?.data?.emails )
        {
          setDeletedEmails( new Set( response.data.emails.map( email => email.toLowerCase() ) ) );
        }
      } catch ( err )
      {
        console.error( 'Failed to fetch deleted emails:', err );
      }
    };
    const fetchDeletedPhones = async () =>
    {
      try
      {
        const response = await getDeletedPhones( accessToken );
        if ( response?.data?.phones )
        {
          setDeletedOutlookPhones( new Set( response.data.phones.map( phone => phone ) ) );
        }
      } catch ( err )
      {
        console.error( 'Failed to fetch deleted emails:', err );
      }
    };

    if ( accessToken )
    {
      fetchDeletedEmails();
      fetchDeletedPhones();
    }
  }, [ accessToken ] );

  useEffect(() => {
  if (accessToken) {
    getAllContacts();
  }
}, [accessToken]);

  const fetchNotes = async ( phone ) =>
  {
    try
    {
      const response = await Get(
        `${apiUrl}/api/v1/zoom/getCallSummary?phone=${phone}`,
        accessToken,
      );
      if ( response?.data )
      {
        const formattedData = {
          caller:
            response.data.data.callDetails.caller.phone_number || 'Unknown',
          callee:
            response.data.data.callDetails.callee.phone_number || 'Unknown',
          events:
            response.data.data.callDetails.events || [],
          summaryReceivedAt:
            response.data.data.date || new Date().toISOString(),
          createdAt: response.data.data.date || new Date().toISOString(),
          zoomSummary: response.data.data.zoomSummary || 'No summary available',
          gptSummary: response.data.data.gptSummary || 'No summary available',
        };

        setPhoneCallSummaries( [ formattedData ] );
        setNotes( [] );
      } else
      {
        setPhoneCallSummaries( [] );
        setNotes( [] );
      }
    } catch ( err )
    {
      console.error( 'Failed to fetch call summary:', err );
      setPhoneCallSummaries( [] );
      setNotes( [] );
    }
  };

  // Create a function to normalize phone numbers for comparison
  const normalizePhoneNumber = ( phone ) =>
  {
    if ( !phone ) return '';
    // Remove all non-digit characters except leading +
    return phone.replace( /[^\d+]/g, '' );
  };

  // Update the fetchPhoneLeads function with better phone comparison
  // const fetchPhoneLeads = async () => {
  //   try {
  //     const [phoneNumbers, customLeadsData, contactsPhonesRes] =
  //       await Promise.all([
  //         Get(`${apiUrl}/api/v1/lead/phone-numbers`, accessToken),
  //         Get(`${apiUrl}/api/v1/lead/custom`, accessToken),
  //         Get(
  //           `${apiUrl}/api/v1/communication/s-contacts-conversion?limit=10000`,
  //           accessToken,
  //           companyId,
  //         ),
  //       ]);

  //     const extractedPhones = extractPhoneNumbers(phoneNumbers.data);
  //     const customLeads = customLeadsData.data.map((lead) => ({
  //       ...lead,
  //       id: lead._id,
  //       type: 'custom',
  //     }));

  //     // Get all contact phone numbers and normalize them
  //     const contactsPhones = Array.isArray(contactsPhonesRes?.data?.result)
  //       ? contactsPhonesRes.data.result
  //           .flatMap(contact => [
  //             contact.contact,
  //             contact.secondaryPhone,
  //             contact.alternativePhone,
  //             contact.cell || ''
  //           ])
  //           .filter(phone => phone && phone.trim() !== '')
  //           .map(normalizePhoneNumber)
  //           .filter(phone => phone !== '')
  //         : [];

  //     const phoneNumbersTabLeads = [...extractedPhones, ...customLeads].filter(
  //       (lead) =>
  //         !lead.firstName &&
  //         !lead.lastName &&
  //         !lead.role &&
  //         !customLeads.some((c) => c.phone === lead.phone),
  //     );

  //     // Filter out phones that are already contacts using normalized comparison
  //     return phoneNumbersTabLeads.filter(
  //       (lead) => !contactsPhones.includes(normalizePhoneNumber(lead.phone))
  //     );
  //   } catch (err) {
  //     console.error('Failed to fetch phone leads:', err);
  //     return [];
  //   }
  // };

  // Update the fetchPhoneLeads function to sort by date
  const fetchPhoneLeads = async () =>
  {
    try
    {
      const [ phoneNumbers, customLeadsData, contactsPhonesRes ] =
        await Promise.all( [
          Get( `${apiUrl}/api/v1/lead/phone-numbers`, accessToken ),
          Get( `${apiUrl}/api/v1/lead/custom`, accessToken ),
          Get(
            `${apiUrl}/api/v1/communication/s-contacts-conversion?limit=10000`,
            accessToken,
            companyId,
          ),
        ] );

      const extractedPhones = extractPhoneNumbers( phoneNumbers.data );
      const customLeads = customLeadsData.data.map( ( lead ) => ( {
        ...lead,
        id: lead._id,
        type: 'custom',
        date: lead.createdAt || lead.updatedAt // Add date for custom leads
      } ) );

      // Sort extracted phones by date (newest first)
      extractedPhones.sort( ( a, b ) => new Date( b.date ) - new Date( a.date ) );

      // Get all contact phone numbers and normalize them
      const contactsPhones = Array.isArray( contactsPhonesRes?.data?.result )
        ? contactsPhonesRes.data.result
          .flatMap( contact => [
            contact.contact,
            contact.secondaryPhone,
            contact.alternativePhone,
            contact.cell || ''
          ] )
          .filter( phone => phone && phone.trim() !== '' )
          .map( normalizePhoneNumber )
          .filter( phone => phone !== '' )
        : [];

      const phoneNumbersTabLeads = [ ...extractedPhones, ...customLeads ].filter(
        ( lead ) =>
          !lead.firstName &&
          !lead.lastName &&
          !lead.role &&
          !customLeads.some( ( c ) => c.phone === lead.phone ),
      );

      // Filter out phones that are already contacts using normalized comparison
      return phoneNumbersTabLeads.filter(
        ( lead ) => !contactsPhones.includes( normalizePhoneNumber( lead.phone ) )
      );
    } catch ( err )
    {
      console.error( 'Failed to fetch phone leads:', err );
      return [];
    }
  };


  // Also update the extractPhoneNumbers function to normalize numbers
  // const extractPhoneNumbers = (data) => {
  //   const phoneNumbers = new Set();

  //   data.forEach((item) => {
  //     try {
  //       if (
  //         item.event === 'phone.caller_ended' ||
  //         item.event === 'phone.callee_ended'
  //       ) {
  //         const payload = item.payload;
  //         if (payload?.object) {
  //           const object = payload.object;
  //           if (
  //             object.caller?.phone_number &&
  //             isValidUsCaNumber(object.caller.phone_number)
  //           ) {
  //             phoneNumbers.add(normalizePhoneNumber(object.caller.phone_number));
  //           }
  //           if (
  //             object.callee?.phone_number &&
  //             object.callee.extension_type === 'pstn' &&
  //             isValidUsCaNumber(object.callee.phone_number)
  //           ) {
  //             phoneNumbers.add(normalizePhoneNumber(object.callee.phone_number));
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error processing phone number:', error);
  //     }
  //   });

  //   return Array.from(phoneNumbers).map((phone, index) => ({
  //     id: `phone-${index}`,
  //     phone,
  //     type: 'zoom phone',
  //   }));
  // };
  // Update the extractPhoneNumbers function to include dates
  const extractPhoneNumbers = ( data ) =>
  {
    const phoneNumbers = new Map(); // Use Map to store latest entry for each phone number

    data.forEach( ( item ) =>
    {
      try
      {
        if (
          item.event === 'phone.caller_ended' ||
          item.event === 'phone.callee_ended'
        )
        {
          const payload = item.payload;
          if ( payload?.object )
          {
            const object = payload.object;
            let phoneNumber = null;
            let date = item.createdAt || item.event_ts;

            // Check caller phone number
            if (
              object.caller?.phone_number &&
              isValidUsCaNumber( object.caller.phone_number )
            )
            {
              phoneNumber = normalizePhoneNumber( object.caller.phone_number );
            }

            // Check callee phone number
            if (
              object.callee?.phone_number &&
              object.callee.extension_type === 'pstn' &&
              isValidUsCaNumber( object.callee.phone_number )
            )
            {
              phoneNumber = normalizePhoneNumber( object.callee.phone_number );
            }

            if ( phoneNumber )
            {
              // Keep only the latest entry for each phone number
              const existingEntry = phoneNumbers.get( phoneNumber );
              if ( !existingEntry || new Date( date ) > new Date( existingEntry.date ) )
              {
                phoneNumbers.set( phoneNumber, {
                  phone: phoneNumber,
                  date: date,
                  id: item._id || `phone-${phoneNumber}`
                } );
              }
            }
          }
        }
      } catch ( error )
      {
        console.error( 'Error processing phone number:', error );
      }
    } );

    return Array.from( phoneNumbers.values() );
  };

  const [ phoneLeadsState, setPhoneLeadsState ] = useState( [] );

  useEffect( () =>
  {
    if ( !outlookAuthenticated ) return;

    const fetchAllLeads = async () =>
    {
      setLoading( true );
      try
      {
        const [ zoomLeads, outlookLeads, outlookContacts, customLeadsData, phoneLeads ] =
          await Promise.all( [
            fetchZoomMeetingLeads(),
            fetchOutlookContacts(),
            fetchAllOutlookContacts(),
            fetchCustomLeads(),
            fetchPhoneLeads(),
          ] );
        setOutlookLeadsState( outlookContacts );
        setPhoneTabCount( phoneLeads.length );
        setPhoneLeadsState( phoneLeads );
      } finally
      {
        setLoading( false );
      }
    };

    fetchAllLeads();
  }, [ accessToken, outlookAuthenticated, contactsEmails, deletedOutlookPhones ] );

  const handleAddPhoneToLeads = async ( lead ) =>
  {
    try
    {
      setActionLoading( ( prev ) => new Set( prev ).add( lead.phone ) );
      await Post(
        `${apiUrl}/api/v1/lead`,
        {
          firstName: '-',
          lastName: '-',
          email: '-',
          phone: lead.phone,
          role: '-',
          __v: 0,
        },
        accessToken,
      );
      const phoneLeads = await fetchPhoneLeads();
      setPhoneLeadsState( phoneLeads );
      setPhoneTabCount( phoneLeads.length );
    } catch ( err )
    {
      console.error( 'Failed to add lead:', err );
    } finally
    {
      setActionLoading( ( prev ) =>
      {
        const newSet = new Set( prev );
        newSet.delete( lead.phone );
        return newSet;
      } );
    }
  };

  const isValidUsCaNumber = ( phoneNumber ) =>
  {
    if ( !phoneNumber ) return false;
    const digits = phoneNumber.replace( /\D/g, '' );
    return (
      digits.length >= 10 && ( digits.startsWith( '1' ) || digits.length > 10 )
    );
  };


  const handleOutlookLogin = () =>
  {
    if ( !userId )
    {
      alert( 'User ID not found in localStorage' );
      return;
    }
    startOutlookLogin(accessToken);
  };

  const fetchZoomMeetingLeads = async () =>
  {
    try
    {
      const url = `${apiUrl}/api/v1/lead`;
      const res = await Get( url, accessToken );
      return res.data.map( ( item, index ) => ( {
        id: `zoom-${index}`,
        email: item.email,
        date: item.createdAt,
        type: 'zoom',
      } ) );
    } catch ( err )
    {
      console.error( 'Failed to fetch ZoomMeeting leads:', err );
      return [];
    }
  };

  const fetchOutlookContacts = async () =>
  {
    try
    {
      const url = `${apiUrl}/api/v1/lead/outlook-contacts/${userId}`;
      const res = await Get( url, accessToken );
      console.log( "res---", res );
      const contacts = res.data || [];
      return contacts.map( ( contact, index ) => ( {
        id: `outlook-${index}`,
        email: contact.emailAddresses?.[ 0 ]?.address || '',
        name: contact.emailAddresses?.[ 0 ]?.name || '',
        type: 'outlook',
      } ) );
    } catch ( err )
    {
      console.error( 'Failed to fetch Outlook contacts:', err );
      return [];
    }
  };

  const fetchAllOutlookContacts = async () =>
  {
    try
    {
      const url = `${apiUrl}/api/v1/lead/outlook-all-contacts/${userId}`;
      const res = await Get( url, accessToken );
      console.log( "outlook res---", res.data.value );
      const contacts = res.data.value || [];
      return contacts.map( ( contact, index ) => ( {
        id: `outlook-${index}`,
        email: contact.emailAddresses?.[ 0 ]?.address || contact.primaryEmailAddress?.address || '',
        name: contact.givenName || contact.surname || '',
        phone: contact.mobilePhone || '',
        type: 'outlook',
      } ) );
    } catch ( err )
    {
      console.error( 'Failed to fetch Outlook contacts:', err );
      return [];
    }
  };

  const syncAllContacts = async () =>
  {
    try
    {
      setSyncing(true);
      const url = `${apiUrl}/api/v1/lead/sync-all-contacts/${userId}`;
      const res = await Get( url, accessToken );
      console.log( "synced contacts---", res.data.createdContactCount );
      alert(`Synced ${res.data.createdContactCount} Contacts`);
      setSyncing(false);
    } catch ( err )
    {
      setSyncing(false);
      console.error( 'Failed to sync contacts:', err );
      return [];
    }
  };

  const getAllContacts = async () =>
  {
    try
    {
      const url = `${apiUrl}/api/v1/lead/get-all-contacts`;
      const res = await Get( url, accessToken );
      console.log( "All Contacts---", res.data );
      if (Array.isArray(res?.data)) {
        // Normalize contact data: ensure email & phone are consistently formatted
        const normalizedContacts = res.data.map(contact => ({
          email: contact.email ? contact.email.toLowerCase().trim() : '',
          phone: contact.contact ? normalizePhoneNumber(contact.contact) : ''
        }));
        setAllContacts(normalizedContacts);
      } else {
        setAllContacts([]);
      }
    } catch ( err )
    {
      console.error( 'Failed to get contacts:', err );
      setAllContacts([]);
    }
  };



  const fetchCustomLeads = async () =>
  {
    try
    {
      const url = `${apiUrl}/api/v1/lead/custom`;
      const res = await Get( url, accessToken );
      return res.data.map( ( lead ) => ( {
        ...lead,
        id: lead._id,
        type: 'custom',
      } ) );
    } catch ( err )
    {
      console.error( 'Failed to fetch custom leads:', err );
      return [];
    }
  };

  const fetchContactsEmails = async () =>
  {
    try
    {
      const url = `${apiUrl}/api/v1/communication/s-contacts-conversion?limit=10000`;
      const res = await Get( url, accessToken, companyId );
      if ( Array.isArray( res?.data?.result ) )
      {
        setContactsEmails( res.data.result.map( ( c ) => c.email.toLowerCase() ) );
      }
    } catch ( err )
    {
      setContactsEmails( [] );
    }
  };

  const refetchAllLeads = async () =>
  {
    // alert( "done" );
    try
    {
      const [ zoomLeads, outlookLeads, outlookContacts, customLeadsData ] = await Promise.all( [
        fetchZoomMeetingLeads(),
        fetchOutlookContacts(),
        fetchAllOutlookContacts(),
        fetchCustomLeads(),
      ] );
      setOutlookLeadsState( filterDenverbbsEmails(outlookContacts) );
      setLeadsData( filterDenverbbsEmails([ ...zoomLeads, ...outlookLeads, ...customLeadsData ]) );
      setCustomLeads( filterDenverbbsEmails(customLeadsData) );
    } catch ( err )
    {
      console.error( 'Failed to refetch leads:', err );
    }
  };

  useEffect( () =>
  {
    if ( !outlookAuthenticated ) return;
    const fetchAllLeads = async () =>
    {
      setLoading( true );
      try
      {
        await refetchAllLeads();
        const customLeadsByEmail = Object.fromEntries(
          customLeads.map( ( lead ) => [ lead.email, lead ] ),
        );
        const mergedLeads = [
          ...leadsData
            .filter( ( lead ) => lead.type === 'zoom' )
            .map( ( zoomLead ) =>
            {
              const customLead = customLeadsByEmail[ zoomLead.email ];
              if ( customLead )
              {
                return { ...customLead, type: 'zoom', source: 'zoom' };
              } else
              {
                return zoomLead;
              }
            } ),
          ...leadsData
            .filter( ( lead ) => lead.type === 'outlook' )
            .map( ( outlookLead ) =>
            {
              const customLead = customLeadsByEmail[ outlookLead.email ];
              if ( customLead )
              {
                return { ...customLead, type: 'outlook', source: 'outlook' };
              } else
              {
                return outlookLead;
              }
            } ),
          ...customLeads.filter(
            ( lead ) =>
              !leadsData.some(
                ( dataLead ) =>
                  ( dataLead.type === 'zoom' || dataLead.type === 'outlook' ) &&
                  dataLead.email === lead.email,
              ),
          ),
        ];
        setMergedLeadsState( mergedLeads );

        const zoomLeads = mergedLeads.filter( ( lead ) =>
        {
          if ( lead.type === 'zoom' )
          {
            return !contactsEmails.includes( lead.email.toLowerCase() );
          }
          if ( lead.type === 'custom' )
          {
            return !contactsEmails.includes( lead.email.toLowerCase() ) && lead.phone !== '-';
          }
          return false;
        } );
        setZoomLeadsState( zoomLeads );

        const outlookLeads = mergedLeads.filter(
          ( lead ) =>
            lead.type === 'outlook' &&
            lead.email &&
            !contactsEmails.includes( lead.email.toLowerCase() ),
        );
        console.log( "outlookLeads", outlookLeads );
        // setOutlookLeadsState(outlookLeads);

        const combinedLeads = [ ...zoomLeads, ...outlookLeads ];
        setCombinedLeadsState( combinedLeads );
      } finally
      {
        setLoading( false );
      }
    };
    fetchAllLeads();
  }, [ accessToken, outlookAuthenticated, contactsEmails ] );

  useEffect( () =>
  {
    fetchContactsEmails();
  }, [ accessToken, companyId ] );

  const handleSubmit = async () =>
  {
    try
    {
      let response;

      const contactData = {
        firstName: zoomEditData.firstName,
        lastName: zoomEditData.lastName,
        contact: zoomEditData.phone
          ? `+1${zoomEditData.phone.replace( /\D/g, '' )}`
          : '',
        email: zoomEditData.newEmail,
        role: zoomEditData.role,
      };

      if ( editId )
      {
        response = await Patch(
          `${apiUrl}/api/v1/lead/${editId}`,
          zoomEditData,
          accessToken,
        );
        await handleContactSync( contactData );
      } else
      {
        response = await Post(
          `${apiUrl}/api/v1/lead`,
          zoomEditData,
          accessToken,
        );
        await handleContactSync( contactData );
      }

      await refetchAllLeads();
      setZoomEditData( {
        oldEmail: '',
        newEmail: '',
        firstName: '',
        lastName: '',
        phone: '',
        address: '',
        role: '',
        leadType: 'custom',
      } );
      setEditId( null );
    } catch ( err )
    {
      console.error( 'Submit failed:', err );
    }
  };

  const handleEdit = ( lead ) =>
  {
    if ( lead.type === 'custom' )
    {
      setZoomEditData( {
        oldEmail: lead.email,
        newEmail: lead.email,
        firstName: lead.firstName || '',
        lastName: lead.lastName || '',
        phone: lead.phone || '',
        address: lead.address || '',
        role: lead.role || '',
        leadType: 'custom',
      } );
      setEditId( lead.id );
      setShowZoomEdit( true );
    }
  };

  const handleZoomEdit = ( lead ) =>
  {
    const hasFullInfo = lead.firstName && lead.lastName;

    const clearDash = ( value ) =>
    {
      return value === '-' ? '' : value;
    };

    setZoomEditData( {
      oldEmail: lead.email,
      newEmail: lead.email,
      firstName: clearDash( lead.firstName || '' ),
      lastName: clearDash( lead.lastName || '' ),
      phone: clearDash( lead.phone || '' ),
      address: clearDash( lead.address || '' ),
      role: clearDash( lead.role || '' ),
      leadType: lead.type,
    } );
    setShowZoomEdit( true );
  };

  const findExistingContact = async ( email ) =>
  {
    try
    {
      const response = await Get(
        `${apiUrl}/api/v1/communication/s-contacts-conversion?search=${email}&limit=1`,
        accessToken,
        companyId,
      );
      if ( response?.data?.result && response.data.result.length > 0 )
      {
        const contact = response.data.result.find( ( c ) => c.email === email );
        return contact;
      }
      return null;
    } catch ( error )
    {
      console.error( 'Error finding existing contact:', error );
      return null;
    }
  };

  const handleContactSync = async ( contactData ) =>
  {
    try
    {
      const existingContact = await findExistingContact( contactData.email );

      if ( existingContact )
      {
        const updateData = {
          firstName: contactData.firstName,
          lastName: contactData.lastName,
          mobilePhone: contactData.contact,
          role: contactData.role,
        };

        const url = `${apiUrl}/api/v1/users/admin/update-user`;
        await Patch( url, updateData, accessToken, companyId );
      } else
      {
        const contactBody = {
          firstName: contactData.firstName,
          lastName: contactData.lastName,
          contact: contactData.contact,
          email: contactData.email,
          role: contactData.role,
        };
        const url = `${apiUrl}/api/v1/communication/contact-regist`;
        await Post( url, contactBody, accessToken, companyId );
      }
    } catch ( contactErr )
    {
      console.error( 'Contact sync failed:', contactErr );
    }
  };

  const handleZoomEditSubmit = async ( e ) =>
  {
    e.preventDefault();
    setSaveLoading( true );
    try
    {
      const leadType = zoomEditData.leadType;

      const contactData = {
        firstName: zoomEditData.firstName,
        lastName: zoomEditData.lastName,
        contact: zoomEditData.phone
          ? `+1${zoomEditData.phone.replace( /\D/g, '' )}`
          : '',
        email: zoomEditData.newEmail,
        role: zoomEditData.role,
        userId: userId
      };

      if ( leadType === 'custom' && !editId )
      {
        await Post(
          `${apiUrl}/api/v1/lead`,
          {
            firstName: zoomEditData.firstName,
            lastName: zoomEditData.lastName,
            email: zoomEditData.newEmail,
            phone: zoomEditData.phone,
            address: zoomEditData.address,
            role: zoomEditData.role,
            userId: userId
          },
          accessToken,
        );
        await handleContactSync( contactData );
      } else
      {
        const customLead = customLeads.find(
          ( lead ) => lead.email === zoomEditData.oldEmail,
        );
        const hasId = !!customLead?.id;
        const endpoint =
          leadType === 'outlook' ? 'outlook-email' : 'zoom-email';

        if ( hasId )
        {
          const updateData = {
            firstName: zoomEditData.firstName,
            lastName: zoomEditData.lastName,
            email: zoomEditData.newEmail,
            phone: zoomEditData.phone,
            address: zoomEditData.address,
            role: zoomEditData.role,
            userId: userId
          };

          if ( zoomEditData.oldEmail !== zoomEditData.newEmail )
          {
            await Patch(
              `${apiUrl}/api/v1/lead/${customLead.id}`,
              updateData,
              accessToken,
            );
            await Patch(
              `${apiUrl}/api/v1/lead/${endpoint}`,
              {
                oldEmail: zoomEditData.oldEmail,
                newEmail: zoomEditData.newEmail,
                firstName: zoomEditData.firstName,
                lastName: zoomEditData.lastName,
                phone: zoomEditData.phone,
                address: zoomEditData.address,
                role: zoomEditData.role,
                userId: userId
              },
              accessToken,
            );
          } else
          {
            await Patch(
              `${apiUrl}/api/v1/lead/${customLead.id}`,
              updateData,
              accessToken,
            );
          }

          await handleContactSync( contactData );
        } else
        {
          await Patch(
            `${apiUrl}/api/v1/lead/${endpoint}`,
            {
              oldEmail: zoomEditData.oldEmail,
              newEmail: zoomEditData.newEmail,
              firstName: zoomEditData.firstName,
              lastName: zoomEditData.lastName,
              phone: zoomEditData.phone,
              address: zoomEditData.address,
              role: zoomEditData.role,
              userId: userId
            },
            accessToken,
          );

          await handleContactSync( contactData );
        }
      }

      await refetchAllLeads();
      setShowZoomEdit( false );
    } catch ( err )
    {
      console.error( 'Zoom/Outlook email update failed:', err );
    } finally
    {
      setSaveLoading( false );
    }
  };

  const isUpgradedLead = ( lead ) =>
  {
    return (
      lead.firstName &&
      lead.lastName &&
      lead.role &&
      lead.firstName !== '-' &&
      lead.lastName !== '-' &&
      lead.role !== '-'
    );
  };

  const handleInputChange = ( e ) =>
  {
    const { name, value } = e.target;
    setZoomEditData( ( prev ) => ( { ...prev, [ name ]: value } ) );
  };

  const isEmailOnlyLead = ( lead ) =>
  {
    return (
      !lead.firstName &&
      !lead.lastName &&
      !lead.role &&
      !customLeads.some( ( customLead ) => customLead.email === lead.email )
    );
  };

  const emailsTabLeads = useMemo( () =>
  {
    return [ ...leadsData, ...customLeads ]
      .filter( ( lead ) => lead.email )
      .filter( isEmailOnlyLead );
  }, [ leadsData, customLeads ] );

  // Unified delete function for all tabs
  const handleDeleteItem = async ( lead ) =>
  {
    try
    {
      // setDeleteLoading( prev => new Set( prev ).add( lead.email || lead.phone || lead.id ) );
      const identifier = lead.email.toLowerCase().trim() !== '-' || lead.phone || lead.id;
      setActionLoading( ( prev ) => new Set( prev ).add( identifier ) );

      // Determine the type of lead and handle accordingly
      if ( lead.email.toLowerCase().trim() === '-' && lead.phone )
      {
        // alert( "ayaa" );
        // Email leads - add to deleted leads
        await addToDeletedPhones( {
          email: "",
          source: lead.type,
          phone: lead.phone || ''
        }, accessToken );

        // Update local state - remove from all relevant arrays
        setDeletedOutlookPhones( prev =>
        {
          const newSet = new Set( prev );
          newSet.add( lead.phone );
          return newSet;
        } );

        // Remove from leadsData and customLeads
        setLeadsData( prev => prev.filter( item => item.phone !== lead.phone ) );
        setCustomLeads( prev => prev.filter( item => item.phone !== lead.phone ) );

        // Remove from combinedLeadsState
        setCombinedLeadsState( prev => prev.filter( item => item.phone !== lead.phone ) );

        // Show success message
        toast.success( 'Phone moved to deleted leads' );
      } else if ( lead.email.toLowerCase().trim() !== '-' )
      {
        // alert( "ayaa2" );
        // Email leads - add to deleted leads
        await addToDeletedLeads( {
          email: lead.email || "",
          source: lead.type,
          phone: lead.phone || ''
        }, accessToken );

        // Update local state - remove from all relevant arrays
        setDeletedEmails( prev =>
        {
          const newSet = new Set( prev );
          newSet.add( lead.email.toLowerCase() );
          return newSet;
        } );

        // Remove from leadsData and customLeads
        setLeadsData( prev => prev.filter( item => item.email !== lead.email ) );
        setCustomLeads( prev => prev.filter( item => item.email !== lead.email ) );

        // Remove from combinedLeadsState
        setCombinedLeadsState( prev => prev.filter( item => item.email !== lead.email ) );

        // Show success message
        toast.success( 'email moved to deleted leads' );
      } else if ( lead.phone )
      {
        // console.log( "ayaa andarr" );
        // Phone leads - delete from phone numbers
        const encoded = encodeURIComponent( lead.phone );
        await Delete(
          `${apiUrl}/api/v1/lead/phone-numbers/${encoded}`,
          null,
          { headers: { Authorization: `Bearer ${accessToken}` } },
          companyId,
        );

        // Update local state
        setDeletedPhones( prev =>
        {
          const newSet = new Set( prev );
          newSet.add( lead.phone );
          return newSet;
        } );

        // Remove from phoneLeadsState
        setPhoneLeadsState( prev => prev.filter( item => item.phone !== lead.phone ) );

        toast.success( 'Phone number deleted' );
      } else if ( lead._id || lead.id )
      {
        // Custom leads or leads with IDs - delete from leads
        const id = lead._id || lead.id;
        await Delete( `${apiUrl}/api/v1/lead/${id}`, null, { headers: { Authorization: `Bearer ${accessToken}` } } );

        // Remove from customLeads and combinedLeadsState
        setCustomLeads( prev => prev.filter( item => item._id !== id && item.id !== id ) );
        setCombinedLeadsState( prev => prev.filter( item => item._id !== id && item.id !== id ) );

        toast.success( 'Lead deleted' );
      }
    } catch ( err )
    {
      console.error( 'Failed to delete item:', err );
      toast.error( 'Failed to delete item' );
    } finally
    {
      setDeleteLoading( prev =>
      {
        const newSet = new Set( prev );
        newSet.delete( lead.email || lead.phone || lead.id );
        return newSet;
      } );
    }
  };

  const handleDeleteItemOutlook = async ( lead ) =>
  {
    try
    {
      setDeleteLoading( prev => new Set( prev ).add( lead.email || lead.phone || lead.id ) );

      // Determine the type of lead and handle accordingly
      if ( lead.email )
      {
        // Email leads - add to deleted leads
        await addToDeletedLeads( {
          email: lead.email,
          source: lead.type,
          phone: lead.phone || ''
        }, accessToken );

        // Update local state - remove from all relevant arrays
        setDeletedEmails( prev =>
        {
          const newSet = new Set( prev );
          newSet.add( lead.email.toLowerCase() );
          return newSet;
        } );

        // Remove from leadsData and customLeads
        setLeadsData( prev => prev.filter( item => item.email !== lead.email ) );
        setCustomLeads( prev => prev.filter( item => item.email !== lead.email ) );

        // Remove from combinedLeadsState
        setCombinedLeadsState( prev => prev.filter( item => item.email !== lead.email ) );

        // Show success message
        toast.success( 'Email moved to deleted leads' );
      } else if ( lead.phone )
      {

        await addToDeletedPhones( {
          email: lead.email || '',
          source: lead.type || '',
          phone: lead.phone || ''
        }, accessToken );

        // Update local state - remove from all relevant arrays
        setDeletedOutlookPhones( prev =>
        {
          const newSet = new Set( prev );
          newSet.add( lead.phone );
          return newSet;
        } );

        // Remove from combinedLeadsState
        setOutlookLeadsState( prev => prev.filter( item => item.phone !== lead.phone ) );

        toast.success( 'Phone number deleted' );
      }
    } catch ( err )
    {
      console.error( 'Failed to delete item:', err );
      toast.error( 'Failed to delete item' );
    } finally
    {
      setDeleteLoading( prev =>
      {
        const newSet = new Set( prev );
        newSet.delete( lead.email || lead.phone || lead.id );
        return newSet;
      } );
    }
  };

  // Filter out deleted emails and phones
  const filteredEmailsTabLeads = useMemo( () =>
  {
    return filterDenverbbsEmails(emailsTabLeads
      .filter( lead =>
        !contactsEmails.includes( lead.email.toLowerCase() ) &&
        !deletedEmails.has( lead.email.toLowerCase() )
      )
      .filter( lead =>
        lead.email.toLowerCase().includes( emailSearch.toLowerCase() ) ||
        lead.type.toLowerCase().includes( emailSearch.toLowerCase() )
      ));
  }, [ emailsTabLeads, contactsEmails, deletedEmails, emailSearch ] );

  const filteredPhoneLeadsState = useMemo( () =>
  {
    return phoneLeadsState
      .filter( lead => !deletedPhones.has( lead.phone ) )
      .filter( lead =>
        lead.phone.includes( phoneSearch )
        // lead.type.toLowerCase().includes( phoneSearch.toLowerCase() )
      );
  }, [ phoneLeadsState, deletedPhones, phoneSearch ] );

  // const filteredCombinedLeadsState = useMemo( () =>
  // {
  //   return filterDenverbbsEmails(combinedLeadsState
  //     .filter( lead =>
  //     {
  //       // For leads with emails, check if they're deleted
  //       if ( lead.email.toLowerCase().trim() !== '-')
  //       {
  //         return !deletedEmails.has( lead.email.toLowerCase() );
  //       } else if ( lead.phone )
  //       {
  //         return !deletedOutlookPhones.has( lead.phone );
  //       }
  //       // For leads without emails, just include them
  //       return true;
  //     } )
  //     .filter( lead =>
  //       ( lead.email && lead.email.toLowerCase().includes( leadsSearch.toLowerCase() ) ) ||
  //       ( lead.phone && lead.phone.includes( leadsSearch ) ) ||
  //       lead.type.toLowerCase().includes( leadsSearch.toLowerCase() ) ||
  //       ( lead.firstName && lead.firstName.toLowerCase().includes( leadsSearch.toLowerCase() ) ) ||
  //       ( lead.lastName && lead.lastName.toLowerCase().includes( leadsSearch.toLowerCase() ) ) ||
  //       ( lead.role && lead.role.toLowerCase().includes( leadsSearch.toLowerCase() ) )
  //     ));
  // }, [ combinedLeadsState, deletedEmails, deletedOutlookPhones, leadsSearch ] );

const filteredCombinedLeadsState = useMemo(() => {
  let result = combinedLeadsState
    .filter(lead => {
      // For leads with emails, check if they're deleted
      if (lead.email.toLowerCase().trim() !== '-') {
        return !deletedEmails.has(lead.email.toLowerCase());
      } else if (lead.phone) {
        return !deletedOutlookPhones.has(lead.phone);
      }
      // For leads without emails, just include them
      return true;
    })
    .filter(lead =>
      (lead.email && lead.email.toLowerCase().includes(leadsSearch.toLowerCase())) ||
      (lead.phone && lead.phone.includes(leadsSearch)) ||
      lead.type.toLowerCase().includes(leadsSearch.toLowerCase()) ||
      (lead.firstName && lead.firstName.toLowerCase().includes(leadsSearch.toLowerCase())) ||
      (lead.lastName && lead.lastName.toLowerCase().includes(leadsSearch.toLowerCase())) ||
      (lead.role && lead.role.toLowerCase().includes(leadsSearch.toLowerCase()))
    )
    // Sort by date in descending order (newest first)
    .sort((a, b) => {
      // Get date from either date or createdAt field, with fallback to 0
      const getDate = (item) => {
        if (item.date) return new Date(item.date);
        if (item.createdAt) return new Date(item.createdAt);
        return new Date(0); // Fallback for items without date
      };
      
      const dateA = getDate(a);
      const dateB = getDate(b);
      return dateB - dateA; // Descending order (newest first)
    });

  result = result.filter(lead => {
    const leadEmail = lead.email ? lead.email.toLowerCase().trim() : '';
    const leadPhone = lead.phone ? normalizePhoneNumber(lead.phone) : '';

    const validEmail = leadEmail && leadEmail !== '-';
    const validPhone = leadPhone && leadPhone !== '-';
    // If no valid identifier, keep it (or skip — your choice)
    if (!validEmail && !validPhone) {
      return true; // or false if you want to hide such leads
    }

    // Check against `allContacts` (which must contain { email, phone })
    const isDuplicate = allContacts.some(contact => {
      return (
        (validEmail && contact.email === leadEmail) ||
        (validPhone && contact.phone === leadPhone)
      );
    });
    console.log(`LeadEmail : ${validEmail} - LeadPhone : ${validPhone} - Duplicate : ${isDuplicate} `);
    return !isDuplicate; // ← only keep if NOT in contacts
  });

  return filterDenverbbsEmails(result);
}, [combinedLeadsState, deletedEmails, deletedOutlookPhones, leadsSearch,allContacts]);

  const filteredOutlookLeadsState = useMemo( () =>
  {
    return filterDenverbbsEmails(outlookLeadsState
      .filter( lead =>
      {
        // For leads with emails, check if they're deleted
        if ( lead.email )
        {
          return !deletedEmails.has( lead.email.toLowerCase() );
        }
        else if ( lead.phone )
        {
          return !deletedOutlookPhones.has( lead.phone );
        }
        // For leads without emails, just include them
        return false;
      } )
      .filter( lead =>
        ( lead.email && lead.email.toLowerCase().includes( contactSearch.toLowerCase() ) ) ||
        ( lead.phone && lead.phone.includes( contactSearch.toLowerCase() ) ) ||
        ( lead.name && lead.name.toLowerCase().includes( contactSearch.toLowerCase() ) )
      ));
  }, [ outlookLeadsState, deletedEmails, deletedOutlookPhones, contactSearch ] );

  const handleAddToLeads = async ( lead ) =>
  {
    // console.log( "handleAddToLeads", lead.email );
    // alert( lead );
    try
    {
      setActionLoading( ( prev ) => new Set( prev ).add( lead.email ) );
      const endpoint = lead.type === 'outlook' ? 'outlook-email' : 'zoom-email';
      await Patch(
        `${apiUrl}/api/v1/lead/${endpoint}`,
        {
          oldEmail: lead.email,
          newEmail: lead.email,
          firstName: '-',
          lastName: '-',
          phone: '-',
          role: '-',
        },
        accessToken,
      );
      await refetchAllLeads();
    } catch ( err )
    {
      console.error( 'Failed to add lead:', err );
    } finally
    {
      setActionLoading( ( prev ) =>
      {
        const newSet = new Set( prev );
        newSet.delete( lead.email );
        return newSet;
      } );
    }
  };

  const handleAddToLeadsOutlook = async ( lead ) =>
  {
    // console.log( "handleAddToLeads", lead.email );
    // alert( lead );
    try
    {
      const identifier = lead.email || lead.phone;
      setActionLoading( ( prev ) => new Set( prev ).add( identifier ) );

      if ( lead.email )
      {
        // alert( "step 1" );
        // setActionLoading( ( prev ) => new Set( prev ).add( lead.email ) );
        const endpoint = lead.type === 'outlook' ? 'outlook-email' : 'zoom-email';
        await Patch(
          `${apiUrl}/api/v1/lead/${endpoint}`,
          {
            oldEmail: lead.email,
            newEmail: lead.email,
            firstName: '-',
            lastName: '-',
            phone: '-',
            role: '-',
          },
          accessToken,
        );
      } else if ( lead.phone )
      {
        // alert( "step 2" );
        // setActionLoading( ( prev ) => new Set( prev ).add( lead.phone ) );
        // alert( lead.phone );
        const endpoint = 'outlook-phone';
        await Patch(
          `${apiUrl}/api/v1/lead/${endpoint}`,
          {
            oldEmail: '-',
            newEmail: '-',
            firstName: '-',
            lastName: '-',
            phone: lead.phone,
            role: '-',
          },
          accessToken,
        );
      }
      handleRefresh();
    } catch ( err )
    {
      console.error( 'Failed to add lead:', err );
      toast.error( 'Failed to add lead to Outlook' );
    } finally
    {
      setActionLoading( ( prev ) =>
      {
        const newSet = new Set( prev );
        if ( lead.email ) newSet.delete( lead.email );
        if ( lead.phone ) newSet.delete( lead.phone );
        return newSet;
      } );
    }
  };

  const handleTabChange = ( event, newValue ) =>
  {
    setCurrentTab( newValue );
  };

  // Refresh function to reload all data
  const handleRefresh = async () =>
  {
    setRefreshing( true );
    try
    {
      // Clear search terms
      setEmailSearch( '' );
      setPhoneSearch( '' );
      setLeadsSearch( '' );
      setContactSearch( '' );

      // Refetch all data
      await Promise.all( [
        fetchContactsEmails(),
        fetchZoomMeetingLeads(),
        fetchOutlookContacts(),
        fetchAllOutlookContacts(),
        fetchCustomLeads(),
        fetchPhoneLeads(),
        getDeletedEmails( accessToken ).then( response =>
        {
          if ( response?.data?.emails )
          {
            setDeletedEmails( new Set( response.data.emails.map( email => email.toLowerCase() ) ) );
          }
        } ),
        getDeletedPhones( accessToken ).then( response =>
        {
          if ( response?.data?.phones )
          {
            setDeletedOutlookPhones( new Set( response.data.phones.map( phone => phone ) ) );
          }
        } )
      ] );

      // Refetch the main leads data
      await refetchAllLeads();

      toast.success( 'Data refreshed successfully' );
    } catch ( error )
    {
      console.error( 'Failed to refresh data:', error );
      toast.error( 'Failed to refresh data' );
    } finally
    {
      setRefreshing( false );
    }
  };

  console.log( "outlookLeadsState---", outlookLeadsState );
  console.log( "filteredCombinedLeadsState--", filteredCombinedLeadsState );
  console.log( "combinedLeadsState--", combinedLeadsState );
  console.log( "allContacts--", allContacts );

  return (
    <>
      <style>{`
        :root{
          overflow-y: hidden;
        }
        .leads-delete-btn {
          background-color: #dc3545;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          transition: background-color 0.2s;
        }
        .leads-delete-btn:hover:not(:disabled) {
          background-color: #c82333;
        }
        .leads-delete-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .leads-edit-btn {
          background-color: #0072C6;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          transition: background-color 0.2s;
        }
        .leads-edit-btn:hover:not(:disabled) {
          background-color: #005A9E;
        }
        .leads-edit-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .search-container {
          margin-bottom: 20px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .search-box {
          position: relative;
          width: 300px;
        }
        .search-input {
          width: 100%;
          padding: 12px 20px 12px 45px;
          border: none;
          border-radius: 25px;
          background: #f5f7fa;
          font-size: 14px;
          box-shadow: 0 2px 10px rgba(0, 114, 198, 0.1);
          transition: all 0.3s ease;
          color: #2c3e50;
        }
        .search-input:focus {
          outline: none;
          box-shadow: 0 2px 15px rgba(0, 114, 198, 0.2);
          background: white;
        }
        .search-input::placeholder {
          color: #a0aec0;
        }
        .search-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: #0072C6;
          width: 18px;
          height: 18px;
        }
        .clear-search {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #a0aec0;
          cursor: pointer;
          font-size: 16px;
          transition: color 0.2s;
        }
        .clear-search:hover {
          color: #0072C6;
        }
        .tab-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          flex-wrap: wrap;
          gap: 15px;
        }
        .search-info {
          font-size: 12px;
          color: #718096;
          margin-top: 5px;
          text-align: right;
        }
        .refresh-button {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-left: auto;
          margin-right: 16px;
        }
        @media (max-width: 768px) {
          .tab-header {
            flex-direction: column;
            align-items: flex-start;
          }
          .search-container {
            width: 100%;
            justify-content: flex-start;
          }
          .search-box {
            width: 100%;
          }
          .refresh-button {
            margin-left: 0;
            margin-right: 0;
            margin-top: 10px;
          }
        }
      `}</style>
      <SideBarSkeleton>
        <section className="px-3 py-6">
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Tabs
              value={currentTab}
              onChange={handleTabChange}
              sx={{
                '& .MuiTab-root': {
                  fontWeight: 600,
                  fontSize: '1rem',
                  textTransform: 'none',
                },
                '& .Mui-selected': {
                  color: '#0072C6',
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#0072C6',
                },
              }}
            >
              <Tab label={`Emails (${filteredEmailsTabLeads.length})`} />
              <Tab label={`Phone (${filteredPhoneLeadsState.length})`} />
              <Tab label={`Leads (${filteredCombinedLeadsState.length})`} />
              <Tab label={`Outlook (${filteredOutlookLeadsState.length})`} />
            </Tabs>

            <section>
            {/* Refresh Button */}
            <Button
              variant="outlined"
              onClick={handleRefresh}
              disabled={refreshing}
              startIcon={<Refresh />}
              sx={{
                marginRight: 2,
                textTransform: 'none',
                color: '#0072C6',
                borderColor: '#0072C6',
                '&:hover': {
                  backgroundColor: '#0072C6',
                  color: 'white',
                  borderColor: '#0072C6',
                },
              }}
            >
              {refreshing ? 'Refreshing...' : 'Refresh'}
            </Button>
            <Button
              variant="outlined"
              onClick={syncAllContacts}
              disabled={refreshing}
              startIcon={<Refresh />}
              sx={{
                marginRight: 2,
                textTransform: 'none',
                color: '#0072C6',
                borderColor: '#0072C6',
                '&:hover': {
                  backgroundColor: '#0072C6',
                  color: 'white',
                  borderColor: '#0072C6',
                },
              }}
            >
              {syncing ? "Syncing Contacts" : "Sync Contacts"}
            </Button>
          </section>
          </Box>

          {/* Search boxes for each tab */}
          {currentTab === 0 && (
            <div className="tab-header">
              <div>
                <h3 style={{ margin: 0, color: '#2c3e50' }}>Email Leads</h3>
                <p style={{ margin: '5px 0 0 0', color: '#718096', fontSize: '14px' }}>
                  Manage your email leads and add them to your contact list
                </p>
              </div>
              <div className="search-container">
                <div className="search-box">
                  {/* Search icon SVG */}
                  <svg className="search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <input
                    type="text"
                    placeholder="Search emails or sources..."
                    value={emailSearch}
                    onChange={( e ) => setEmailSearch( e.target.value )}
                    className="search-input"
                  />
                  {emailSearch && (
                    <button
                      className="clear-search"
                      onClick={() => setEmailSearch( '' )}
                      aria-label="Clear search"
                    >
                      ×
                    </button>
                  )}
                </div>
                {emailSearch && (
                  <div className="search-info">
                    {filteredEmailsTabLeads.length} result{filteredEmailsTabLeads.length !== 1 ? 's' : ''} found
                  </div>
                )}
              </div>
            </div>
          )}

          {currentTab === 1 && (
            <div className="tab-header">
              <div>
                <h3 style={{ margin: 0, color: '#2c3e50' }}>Phone Leads</h3>
                <p style={{ margin: '5px 0 0 0', color: '#718096', fontSize: '14px' }}>
                  Manage phone numbers from Zoom calls and other sources
                </p>
              </div>
              <div className="search-container">
                <div className="search-box">
                  {/* Search icon SVG */}
                  <svg className="search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                  <input
                    type="text"
                    placeholder="Search phone numbers or sources..."
                    value={phoneSearch}
                    onChange={( e ) => setPhoneSearch( e.target.value )}
                    className="search-input"
                  />
                  {phoneSearch && (
                    <button
                      className="clear-search"
                      onClick={() => setPhoneSearch( '' )}
                      aria-label="Clear search"
                    >
                      ×
                    </button>
                  )}
                </div>
                {phoneSearch && (
                  <div className="search-info">
                    {filteredPhoneLeadsState.length} result{filteredPhoneLeadsState.length !== 1 ? 's' : ''} found
                  </div>
                )}
              </div>
            </div>
          )}

          {currentTab === 2 && (
            <div className="tab-header">
              <div>
                <h3 style={{ margin: 0, color: '#2c3e50' }}>All Leads</h3>
                <p style={{ margin: '5px 0 0 0', color: '#718096', fontSize: '14px' }}>
                  View and manage all your leads in one place
                </p>
              </div>
              <div className="search-container">
                <div className="search-box">
                  {/* Search icon SVG */}
                  <svg className="search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <input
                    type="text"
                    placeholder="Search by email, phone, name, role..."
                    value={leadsSearch}
                    onChange={( e ) => setLeadsSearch( e.target.value )}
                    className="search-input"
                  />
                  {leadsSearch && (
                    <button
                      className="clear-search"
                      onClick={() => setLeadsSearch( '' )}
                      aria-label="Clear search"
                    >
                      ×
                    </button>
                  )}
                </div>
                {leadsSearch && (
                  <div className="search-info">
                    {filteredCombinedLeadsState.length} result{filteredCombinedLeadsState.length !== 1 ? 's' : ''} found
                  </div>
                )}
              </div>
            </div>
          )}

          {currentTab === 3 && (
            <div className="tab-header">
              <div>
                <h3 style={{ margin: 0, color: '#2c3e50' }}>All Contacts</h3>
                <p style={{ margin: '5px 0 0 0', color: '#718096', fontSize: '14px' }}>
                  View and manage all your Contacts in one place
                </p>
              </div>
              <div className="search-container">
                <div className="search-box">
                  {/* Search icon SVG */}
                  <svg className="search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <input
                    type="text"
                    placeholder="Search by email, name..."
                    value={contactSearch}
                    onChange={( e ) => setContactSearch( e.target.value )}
                    className="search-input"
                  />
                  {contactSearch && (
                    <button
                      className="clear-search"
                      onClick={() => setContactSearch( '' )}
                      aria-label="Clear search"
                    >
                      ×
                    </button>
                  )}
                </div>
                {contactSearch && (
                  <div className="search-info">
                    {filteredOutlookLeadsState.length} result{filteredOutlookLeadsState.length !== 1 ? 's' : ''} found
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Emails Tab */}
          {currentTab === 0 && (
            <LeadsTable
              data={filteredEmailsTabLeads}
              loading={loading}
              emptyMessage={emailSearch ? "No matching emails found" : "No emails found"}
              columns={[
                {
                  header: 'Source',
                  key: 'type',
                  width: '35%',
                  align: 'left',
                },
                {
                  header: 'Email',
                  key: 'email',
                  width: '50%',
                  align: 'left',
                },
                {
                  header: 'Actions',
                  width: '15%',
                  align: 'center',
                  render: ( lead ) => (
                    <>
                      {actionLoading.has( lead.email ) || deleteLoading.has( lead.email ) ? (
                        <CircularProgress
                          size={20}
                          style={{ color: '#0072C6' }}
                        />
                      ) : (
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                          <button
                            onClick={() => handleAddToLeads( lead )}
                            className="leads-edit-btn"
                            disabled={actionLoading.has( lead.email ) || deleteLoading.has( lead.email )}
                          >
                            Add to Leads
                          </button>
                          <button
                            onClick={() => handleDeleteItem( lead )}
                            className="leads-delete-btn"
                            disabled={actionLoading.has( lead.email ) || deleteLoading.has( lead.email )}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </>
                  ),
                },
              ]}
            />
          )}

          {currentTab === 1 && (
            <LeadsTable
              data={filteredPhoneLeadsState}
              loading={loading}
              emptyMessage={phoneSearch ? "No matching phone numbers found" : "No valid US/CA phone numbers found"}
              skeletonRows={16}
              skeletonCols={3}
              columns={[
                {
                  header: 'Date',
                  key: 'date',
                  width: '35%',
                  align: 'left',
                  render: ( lead ) =>
                  {
                    if ( !lead.date ) return 'N/A';
                    try
                    {
                      const date = new Date( lead.date );
                      return date.toLocaleDateString( 'en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      } );
                    } catch ( e )
                    {
                      return 'Invalid Date';
                    }
                  },
                },
                {
                  header: 'Phone Number',
                  key: 'phone',
                  width: '50%',
                  align: 'left',
                },
                {
                  header: 'Actions',
                  width: '15%',
                  align: 'center',
                  render: ( lead ) => (
                    <div
                      style={{ display: 'flex', gap: 8, alignItems: 'center' }}
                    >
                      {actionLoading.has( lead.phone ) || deleteLoading.has( lead.phone ) ? (
                        <CircularProgress
                          size={20}
                          style={{ color: '#0072C6' }}
                        />
                      ) : (
                        <>
                          <button
                            onClick={() => handleAddPhoneToLeads( lead )}
                            className="leads-edit-btn"
                            disabled={actionLoading.has( lead.phone ) || deleteLoading.has( lead.phone )}
                            style={{ textWrap: 'nowrap' }}
                          >
                            Add to Leads
                          </button>
                          <button
                            onClick={() => handleDeleteItem( lead )}
                            className="leads-delete-btn"
                            disabled={actionLoading.has( lead.phone ) || deleteLoading.has( lead.phone )}
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          )}

          {/* Combined Leads Tab (Zoom + Outlook) */}
          {currentTab === 2 && (
            <LeadsTable
              data={filteredCombinedLeadsState}
              loading={loading}
              emptyMessage={leadsSearch ? "No matching leads found" : "No leads found"}
              columns={[
                {
                  header: 'Source',
                  key: 'type',
                  width: '15%',
                  align: 'left',
                  render: ( lead ) =>
                    lead.type.charAt( 0 ).toUpperCase() + lead.type.slice( 1 ),
                },
                {
                  header: 'Date',
                  key: 'date',
                  width: '15%',
                  align: 'left',
                  render: (lead) => {
                    // Use either date or createdAt field
                    const dateValue = lead.date || lead.createdAt;
                    if (!dateValue) return 'N/A';
                    
                    try {
                      const date = new Date(dateValue);
                      return date.toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                      });
                    } catch (e) {
                      return 'Invalid Date';
                    }
                  },
                },
                {
                  header: 'Email',
                  key: 'email',
                  width: '25%',
                  align: 'left',
                },
                {
                  header: 'Phone',
                  key: 'phone',
                  width: '15%',
                  align: 'left',
                  render: ( lead ) => lead.phone || 'N/A',
                },
                {
                  header: 'Actions',
                  width: '20%',
                  align: 'center',
                  render: ( lead ) => (
                    <div
                      style={{
                        display: 'flex',
                        gap: 8,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {lead.phone && lead.phone !== '-' && (
                        <MdChat
                          size={24}
                          color={
                            selectedItem?.id === lead.id ? 'yellow' : '#0072C6'
                          }
                          onClick={( event ) =>
                          {
                            setSelectedItem( lead );
                            fetchNotes( lead.phone );
                            setNotesPopupAnchor(
                              notesPopupAnchor ? null : event.currentTarget,
                            );
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                      <button
                        onClick={() => handleZoomEdit( lead )}
                        className="leads-edit-btn"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeleteItem( lead )}
                        className="leads-delete-btn"
                        disabled={deleteLoading.has( lead.email || lead.phone || lead.id )}
                      >
                        {deleteLoading.has( lead.email || lead.phone || lead.id )
                          ? 'Deleting...'
                          : 'Delete'}
                      </button>
                    </div>
                  ),
                },
              ]}
            />
          )}

          {/*outlook tab*/}
          {currentTab === 3 && (
            <LeadsTable
              data={filteredOutlookLeadsState}
              loading={loading}
              emptyMessage={contactSearch ? "No matching contacts found" : "No contacts found"}
              columns={[
                {
                  header: 'Source',
                  key: 'type',
                  width: '20%',
                  align: 'left',
                  render: ( lead ) =>
                    lead.type.charAt( 0 ).toUpperCase() + lead.type.slice( 1 ),
                },
                // {
                //   header: 'Date',
                //   key: 'date',
                //   width: '15%',
                //   align: 'left',
                //   render: ( lead ) =>
                //   {
                //     if ( !lead.date ) return 'N/A';
                //     const date = new Date( lead.date );
                //     return date.toLocaleDateString( 'en-US', {
                //       year: 'numeric',
                //       month: 'short',
                //       day: 'numeric',
                //     } );
                //   },
                // },
                {
                  header: 'Name',
                  key: 'name',
                  width: '20%',
                  align: 'left',
                },
                {
                  header: 'Email',
                  key: 'email',
                  width: '20%',
                  align: 'left',
                },
                {
                  header: 'Phone',
                  key: 'phone',
                  width: '20%',
                  align: 'left',
                  render: ( lead ) => lead.phone || 'N/A',
                },
                {
                  header: 'Actions',
                  width: '20%',
                  align: 'center',
                  render: ( lead ) => (
                    <>
                      {
                        actionLoading.has( lead.email || lead.phone ) || deleteLoading.has( lead.email || lead.phone ) ? (
                          <CircularProgress
                            size={20}
                            style={{ color: '#0072C6' }}
                          />
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              gap: 8,
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            {/* {lead.phone && lead.phone !== '-' && (
                        <MdChat
                          size={24}
                          color={
                            selectedItem?.id === lead.id ? 'yellow' : '#0072C6'
                          }
                          onClick={(event) => {
                            setSelectedItem(lead);
                            fetchNotes(lead.phone);
                            setNotesPopupAnchor(
                              notesPopupAnchor ? null : event.currentTarget,
                            );
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      )} */}
                            <button
                              onClick={() => handleAddToLeadsOutlook( lead )}
                              className="leads-edit-btn"
                              disabled={actionLoading.has( lead.email || lead.phone ) || deleteLoading.has( lead.email || lead.phone )}
                            >
                              Add to Leads
                            </button>
                            <button
                              onClick={() => handleDeleteItemOutlook( lead )}
                              className="leads-delete-btn"
                              disabled={deleteLoading.has( lead.email || lead.phone || lead.id )}
                            >
                              {deleteLoading.has( lead.email || lead.phone || lead.id )
                                ? 'Deleting...'
                                : 'Delete'}
                            </button>
                          </div>
                        )
                      }
                    </>
                  ),
                },
              ]}
            />
          )}

          {notesPopupAnchor && (
            <NotesDetailPopup
              anchor={notesPopupAnchor}
              notes={notes}
              phoneCallSummaries={phoneCallSummaries}
              onClose={() =>
              {
                setNotes( [] );
                setPhoneCallSummaries( [] );
                setSelectedItem( null );
                setNotesPopupAnchor( null );
              }}
              title={`Call Summary - ${selectedItem?.phone}`}
              showAddNote={false}
            />
          )}

          <Dialog
            open={showZoomEdit}
            onClose={() => setShowZoomEdit( false )}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle
              sx={{
                display: 'flex',
                alignItems: 'start',
                justifyContent: 'space-between',
              }}
            >
              <Typography component="h5" variant="h5">
                {editId
                  ? 'Edit Custom Lead'
                  : zoomEditData.leadType === 'outlook'
                    ? 'Upgrade Outlook Email'
                    : zoomEditData.leadType === 'zoom'
                      ? 'Upgrade Zoom Meeting Email'
                      : 'Add/Upgrade Lead'}
              </Typography>
              <IconButton onClick={() => setShowZoomEdit( false )}>
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <form id="leads-upgrade-form" onSubmit={handleZoomEditSubmit}>
                <Box py={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        name="firstName"
                        label="First Name"
                        value={zoomEditData.firstName}
                        onChange={handleInputChange}
                        fullWidth
                        required
                        autoFocus
                        disabled={saveLoading}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        name="lastName"
                        label="Last Name"
                        value={zoomEditData.lastName}
                        onChange={handleInputChange}
                        fullWidth
                        required
                        disabled={saveLoading}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        type="email"
                        name="newEmail"
                        label="Email"
                        value={zoomEditData.newEmail}
                        onChange={handleInputChange}
                        fullWidth
                        required
                        disabled={saveLoading}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        name="phone"
                        label="Phone"
                        value={zoomEditData.phone}
                        onChange={handleInputChange}
                        fullWidth
                        required
                        disabled={saveLoading}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        select
                        name="role"
                        label="Role"
                        value={zoomEditData.role}
                        onChange={handleInputChange}
                        fullWidth
                        required
                        disabled={saveLoading}
                      >
                        <MenuItem value="">Select Role</MenuItem>
                        {rolesOptions.map( ( r ) => (
                          <MenuItem key={r.value} value={r.value}>
                            {r.label}
                          </MenuItem>
                        ) )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Box>
              </form>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
              <Button
                type="submit"
                form="leads-upgrade-form"
                variant="contained"
                disabled={saveLoading}
                sx={{
                  backgroundColor: '#0072C6',
                  fontFamily: "'Open Sans', sans-serif",
                  fontWeight: '500',
                  '&:hover': {
                    backgroundColor: '#005A9E',
                  },
                  padding: '10px 20px',
                  fontSize: '16px',
                }}
              >
                {saveLoading ? (
                  <>
                    <CircularProgress
                      size={16}
                      sx={{ color: 'white', mr: 1 }}
                    />
                    Saving...
                  </>
                ) : editId ? (
                  'Update Lead'
                ) : (
                  'Save'
                )}
              </Button>
              <Button
                onClick={() => setShowZoomEdit( false )}
                variant="contained"
                disabled={saveLoading}
                sx={{
                  backgroundColor: '#dc3545',
                  fontFamily: "'Open Sans', sans-serif",
                  fontWeight: '500',
                  '&:hover': {
                    backgroundColor: '#a71d2a',
                  },
                  padding: '10px 20px',
                  fontSize: '16px',
                }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </section>
      </SideBarSkeleton>
    </>
  );
};

export default Leads;